import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import { addDenyUserList } from '../actions/denyUserList';

export default handleActions<DamzState['denyUserList'], any>(
  {
    [`${addDenyUserList}`]: (state, action: ReturnType<typeof addDenyUserList>) => ({
      ...state,
      [action.payload.username]: true,
    }),
  },
  {}
);
